import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useNotification } from '../../contextApi/NotificationProvider';
import { updateManager } from '../../redux/ReduxSlices/managerSlice';
import { getUserDetails } from '../../redux/ReduxSlices/authSlice';

const EditManagerPopup = ({ updateData, setEditManagerPopup }) => {
    const dispatch = useDispatch();
    const { showNotification } = useNotification();

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting: loading },
    } = useForm({
        defaultValues: {
            firstName: updateData?.firstName || '',
            lastName: updateData?.lastName || ''
        }
    });

    const onSubmit = async (data) => {
        try {
            const payload = {
                user_id: updateData.id,
                first_name: data.firstName,
                last_name: data.lastName
            }
            const response = await dispatch(updateManager(payload)).unwrap()
            if (response.success) {
                showNotification(response.message, "success");
                dispatch(getUserDetails())
            }

            setEditManagerPopup(false);
        } catch (error) {
            console.error("Update failed:", error);
            showNotification("Failed to update", "error");
        }
    };

    return (
        <div className="fixed inset-0 bg-black backdrop-blur-sm bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
                <div className="p-6">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="text-lg font-semibold text-gray-800">{updateData.title}</h3>
                        <button
                            onClick={() => setEditManagerPopup(false)}
                            className="text-gray-400 hover:text-gray-500"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
                        <div className="flex gap-4">
                            <div className="w-1/2">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    First Name
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter first name"
                                    {...register("firstName", {
                                        required: "First name is required",
                                        minLength: {
                                            value: 2,
                                            message: "First name must be at least 2 characters",
                                        },
                                        maxLength: {
                                            value: 30,
                                            message: "First name must be at most 30 characters",
                                        },
                                        pattern: {
                                            value: /^[A-Za-z]+$/,
                                            message: "First name can only contain letters and valid characters",
                                        }
                                    })}
                                    className={`w-full border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 ${errors.firstName
                                        ? "border-red-500 focus:ring-red-400"
                                        : "border-gray-300 focus:ring-violet-500"
                                        }`}
                                />
                                {errors.firstName && (
                                    <p className="text-xs text-red-500 mt-1">
                                        {errors.firstName.message}
                                    </p>
                                )}
                            </div>

                            <div className="w-1/2">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Last Name
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter last name"
                                    {...register("lastName", {
                                        required: "Last name is required",
                                        minLength: {
                                            value: 2,
                                            message: "Last name must be at least 2 characters",
                                        },
                                        maxLength: {
                                            value: 30,
                                            message: "Last name must be at most 30 characters",
                                        },
                                        pattern: {
                                            value: /^[A-Za-z]+$/,
                                            message: "Last name can only contain letters and valid characters",
                                        }
                                    })}

                                    className={`w-full border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 ${errors.lastName
                                        ? "border-red-500 focus:ring-red-400"
                                        : "border-gray-300 focus:ring-violet-500"
                                        }`}
                                />
                                {errors.lastName && (
                                    <p className="text-xs text-red-500 mt-1">
                                        {errors.lastName.message}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="flex justify-end gap-3 pt-2">
                            <button
                                type="button"
                                onClick={() => setEditManagerPopup(false)}
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-violet-500"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={loading}
                                className="px-4 py-2 text-sm font-medium text-white bg-violet-600 rounded-md hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 disabled:opacity-70 disabled:cursor-not-allowed"
                            >
                                {loading ? 'Updating...' : 'Update'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditManagerPopup;